<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
    <z-page :title="title">
     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'PEMERIKSAAN FIZIKAL AM'" >
      <div class="w-card__content content-hardcode">
       <template v-if="form.jantina==2">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-select class="mt4" :items="skorbadanlist" label="Skor Badan (1-5)" :disabled="form.hantar==1" v-model="form.skor" :validators="[validators.required]"/>
            &nbsp;
            <w-input class="mt4" label="Berat Badan (kg)"  v-model="form.berat" :disabled="form.hantar==1"  :validators="[validators.required]"/>
            &nbsp;
            <div class="grow " >
          <span style="color: black"><h2> Tanda Klinikal Penyakit <w-icon class="fal fa-info-circle"></w-icon> </h2></span>
            <br>
           <w-radios
                  class="mr2"
                  v-model="form.tanda_klinikan"
                  :items="tanda_list"
                  inline
                  color="blue-light1" :disabled="form.hantar==1">
                </w-radios>
                <template v-if="form.tanda_klinikan==1">
                    <w-input class="mt4" label="Jika YA, sila nyatakan *" type="text" v-model="form.tanda_klinikan_nyatakan" />
                </template>
            </div>
            &nbsp;
          </div>
      </div>

      <div class="grow mb4" style="min-width: 200px">
        <span style="color: black"><h2> Pemeriksaan Locomotor </h2></span>
            </div>
              <div class="w-flex wrap smd-column" >
                <div class="grow " >
                    <span style="color: black"><h2> Otot <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                     <br>
                      <w-radios
                        class="mr2"
                        v-model="form.otot"
                        :items="vulva_list"
                        inline
                        :disabled="form.hantar==1"
                        color="blue-light1">
                      </w-radios>
                      <template v-if="form.otot==2">
                          <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.otot_nyatakan" />
                      </template>
                    </div>
              </div>
        <div class="grow " >
            <div style="margin-top: 40px">
              <span style="color: black"><h2> Sendi <w-icon class="fal fa-info-circle"></w-icon></h2></span>
               <br>
                   <w-radios
                     class="mr2"
                     v-model="form.sendi"
                     :items="vulva_list"
                     inline
                     :disabled="form.hantar==1"
                     color="blue-light1">
                   </w-radios>
                   <template v-if="form.sendi==2">
                       <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.sendi_nyatakan" />
                   </template>
                 </div>
               </div>
            <div class="grow " >
               <div style="margin-top: 40px">
              <span style="color: black"><h2> Postur Badan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.postur"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.postur==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.postur_nyatakan" />
                </template>
          </div>
        </div>
        </template>

  <template v-if="form.jantina==1">
      <w-flex wrap class="text-left">
       <div class="xs6 pa1">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-select class="mt4" :items="skorbadanlist" label="Skor Badan (1-5)" :disabled="form.hantar==1" v-model="form.skor" :validators="[validators.required]"/>
            &nbsp;
            <w-input class="mt4" label="Berat Badan (kg)"  v-model="form.berat" :disabled="form.hantar==1"  :validators="[validators.required]"/>
            &nbsp;
            <div class="grow " >
          <span style="color: black"><h2> Tanda Klinikal Penyakit <w-icon class="fal fa-info-circle"></w-icon> </h2></span>
            <br>
           <w-radios
                  class="mr2"
                  v-model="form.tanda_klinikan"
                  :items="tanda_list"
                  inline
                  color="blue-light1" :disabled="form.hantar==1">
                </w-radios>
                <template v-if="form.tanda_klinikan==1">
                    <w-input class="mt4" label="Jika YA, sila nyatakan *" type="text" v-model="form.tanda_klinikan_nyatakan" />
                </template>
            </div>
            &nbsp;
          </div>
      </div>
     <div class="grow mb4" style="min-width: 200px">
        <span style="color: black"><h2> Pemeriksaan Musculoskeletal </h2></span>
      </div>
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
              <span style="color: black"><h2> Locomotor <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.otot"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.otot==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.otot_nyatakan" />
                </template>
              </div>
        </div>
        <div class="grow " >
            <div style="margin-top: 40px">
              <span style="color: black"><h2> Postur Kaki <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.sendi"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.sendi==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.sendi_nyatakan" />
                </template>
              </div>
            </div>
            <div class="grow " >
               <div style="margin-top: 40px">
              <span style="color: black"><h2> Postur Badan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.postur"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.postur==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.postur_nyatakan" />
                </template>
          </div>
        </div>
   </div>
   <div class="xs6 pa1">
      <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <span style="color: black"><h2> Pemeriksaan Libido <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
            <z-select class="mt4" :items="skorlibidolist" label="Skor Libido (0-10)" :disabled="form.hantar==1" v-model="form.skor_libido" :validators="[validators.required]"/>
         </div>
      </div>
      <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <div style="margin-top: 40px">
            <span style="color: black"><h2> Pemeriksaan Kualiti Semen Dan Spermatozoa <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            </div>   
         <br>
         <z-select class="mt4" :items="pungutan_list" label="Kaedah Pungutan Semen" :disabled="form.hantar==1" v-model="form.pungutan" :validators="[validators.required]"/>
            <br>
             <w-input class="mt4" label="Isipadu (ml)"  v-model="form.isipadu" :disabled="form.hantar==1"  :validators="[validators.required]"/>
             <br>
             <w-input class="mt4" label="Warna"  v-model="form.warna" :disabled="form.hantar==1"  :validators="[validators.required]"/>
             <br>
             <w-input class="mt4" label="Kepekatan"  v-model="form.kepekatan" :disabled="form.hantar==1"  :validators="[validators.required]"/>
             <br>
            <z-select class="mt4" :items="motilitilist" label="Motiliti (0-5)" :disabled="form.hantar==1" v-model="form.motiliti" :validators="[validators.required]"/>
             <br>
             <w-input class="mt4" label="% Motiliti Hidup"  v-model="form.motiliti_hidup" :disabled="form.hantar==1"  :validators="[validators.required]"/>
             <br>
             <w-input class="mt4" label="% Motiliti Progresif"  v-model="form.motiliti_progresif" :disabled="form.hantar==1"  :validators="[validators.required]"/>
             <br>
              <div class="w-flex wrap smd-column" >
                <div class="grow " >
                    <span style="color: black"><h2> Kecacatan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                  <br>
                      <w-radios
                        class="mr2"
                        v-model="form.kecacatan"
                        :items="tanda_list"
                        inline
                        :disabled="form.hantar==1"
                        color="blue-light1">
                      </w-radios>
                      <template v-if="form.kecacatan==1">
                          <w-input class="mt4" label="Jika YA, sila nyatakan kecacatan *" type="text" v-model="form.kecacatan_nyatakan" />
                      </template>
                    </div>
              </div>
            </div>
         </div>
   </div>
</w-flex>
   </template>
    </div>
 
  </w-card>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'PEMERIKSAAN ORGAN GENITAL LUARAN'" >
    <div class="w-card__content content-hardcode">
      <template v-if="form.jantina==2">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <span style="color: black"><h2> Vulva <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.vulva"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.vulva==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.vulva_nyatakan" />
                </template>
            </div>
        </div>
      <div class="grow " >
        <div style="margin-top: 40px">
          <span style="color: black"><h2> Ambing Susu <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.ambing"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.ambing==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.ambing_nyatakan" />
          </template>
      </div>
    </div>
      <div class="grow " >
        <div style="margin-top: 40px">
          <span style="color: black"><h2> Puting Susu <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
          <w-radios
                class="mr2"
                v-model="form.puting"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          <br>
          <template v-if="form.puting==2">
           <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.puting_nyatakan" />
         </template>
      </div>
    </div>
  </template>
  <template v-if="form.jantina==1">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <span style="color: black"><h2> Testis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
                <w-radios
                  class="mr2"
                  v-model="form.testis"
                  :items="vulva_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
                <template v-if="form.testis==2">
                    <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.testis_nyatakan" />
                </template>
            </div>
        </div>
        <div class="grow " >
          <div style="margin-top: 10px">
            <br>
                <z-select class="mt4" :items="testislist" label="Kekenyalan Testis (0-4)" :disabled="form.hantar==1" v-model="form.kekenyalan_testis" :validators="[validators.required]"/>
          </div>
        </div>
        <div class="grow " >
        <div style="margin-top: 40px">
          <span style="color: black"><h2> Epididymis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.epididymis"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.epididymis==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.epididymis_nyatakan" />
          </template>
      </div>
    </div>
    <div class="grow " >
        <div style="margin-top: 40px">
          <span style="color: black"><h2> Korda Spermatik <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.korda"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.korda==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text" v-model="form.korda_nyatakan" />
          </template>
      </div>
    </div>
    <div class="grow " >
        <div style="margin-top: 40px">
          <span style="color: black"><h2> Prepuce / Penis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.penis"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.penis==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.penis_nyatakan" />
          </template>
      </div>
    </div>
  </template>
  </div>
  </w-card>
  <template v-if="form.jantina==1">
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'UKURLILIT SKROTUM CM'" >
      <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-select class="mt4" :items="skrotumlist" label="Ukurlilit Skrotum CM" :disabled="form.hantar==1" v-model="form.skortum" :validators="[validators.required]"/>
          </div>
      </div>
    </div>
  </w-card>
</template>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'PEMERIKSAAN ORGAN GENITAL DALAMAN'" >
   <w-flex wrap class="text-left">
   <div class="xs6 pa1">
    <div class="w-card__content content-hardcode">
    <template v-if="form.jantina==2">
        <div class="grow mb4" style="min-width: 200px">
        <span style="color: black"><h2>1. SERVIK (bentuk)</h2></span>
        </div>
        <div class="grow " >
        <div style="margin-top: 10px">
          <span style="color: black"><h2> Saiz <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.saiz"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.saiz==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.saiz_nyatakan" />
          </template>
      </div>
    </div>
    <br>
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
          <span style="color: black"><h2> Bentuk <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
            <w-radios
                class="mr2"
                v-model="form.bentuk"
                :items="bentuk_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          </div>
        </div>
        <br>
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
          <span style="color: black"><h2> Lokasi <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
            <w-radios
                class="mr2"
                v-model="form.lokasi"
                :items="lokasi_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          </div>
        </div>
        <br>
        <div class="w-flex wrap smd-column" >
         <div class="grow " >
          <span style="color: black"><h2> Kekenyalan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.kekenyalan"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.kekenyalan==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.kekenyalan_nyatakan" />
          </template>
      </div>
    </div>
    <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <div style="margin-top: 30px">
        <span style="color: black"><h2>2. UTERUS</h2></span>
        </div>
         <div class="grow " >
          <div style="margin-top: 30px">
          <span style="color: black"><h2> Simetri <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.simetri"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.simetri==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.simetri_nyatakan" />
          </template>
      </div>
    </div>
    <div class="grow " >
          <div style="margin-top: 30px">
          <span style="color: black"><h2> Bunting <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.bunting"
                :items="tanda_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.bunting==1">
            <w-input class="mt4" label="Jika YA, sila nyatakan *" type="text"  v-model="form.bunting_nyatakan" />
          </template>
      </div>
    </div>
         <div class="grow " >
            <div style="margin-top: 30px">
          <span style="color: black"><h2> Kekenyalan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.kekenyalan_uterus"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.kekenyalan_uterus==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.kekenyalan_uterus_nyatakan" />
          </template>
      </div>
    </div>
    <div class="grow " >
        <div style="margin-top: 30px">
          <span style="color: black"><h2> Saiz <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.saiz_uterus"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.saiz_uterus==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.saiz_uterus_nyatakan" />
          </template>
      </div>
    </div>
  </div>
</div>
    </template>
    <template v-if="form.jantina==1">
    <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <div style="margin-top: 15px">
          <span style="color: black"><h2> Ampullae <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.ampullae"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.ampullae==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.ampullae_nyatakan" />
          </template>
       </div>
        &nbsp;
        <div style="margin-top: 15px">
        <span style="color: black"><h2> Kelenjar Vesikal <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.vesikal"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.vesikal==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.vesikal_nyatakan" />
          </template>
       </div>
        &nbsp;
        <div style="margin-top: 15px">
        <span style="color: black"><h2> Prostat <w-icon class="fal fa-info-circle"></w-icon></h2></span>
          <br>
           <w-radios
                class="mr2"
                v-model="form.prostat"
                :items="vulva_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
              <template v-if="form.prostat==2">
            <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.prostat_nyatakan" />
          </template>
       </div>
        &nbsp;
      </div>
      </div>
    </template>
    </div>
 </div>
 <template v-if="form.jantina==2">
  <div class="xs6 pa1">
      <div class="w-card__content content-hardcode">
            <div class="grow " >
               <span style="color: black"><h2>3. OVARI</h2></span>
                 <div style="margin-top: 20px">
                   <span style="color: black"><h2> Saiz <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                   <br>
                    <w-radios
                         class="mr2"
                         v-model="form.saiz_ovari"
                         :items="vulva_list"
                         inline
                         :disabled="form.hantar==1"
                         color="blue-light1">
                       </w-radios>
                       <template v-if="form.saiz_ovari==2">
                     <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.saiz_ovari_nyatakan" />
                   </template>
               </div>
               <div style="margin-top: 15px">
                   <span style="color: black"><h2> Bentuk <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                   <br>
                    <w-radios
                         class="mr2"
                         v-model="form.bentuk_ovari"
                         :items="vulva_list"
                         inline
                         :disabled="form.hantar==1"
                         color="blue-light1">
                       </w-radios>
                       <template v-if="form.bentuk_ovari==2">
                     <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.bentuk_ovari_nyatakan" />
                   </template>
               </div>
               <div style="margin-top: 15px">
                   <span style="color: black"><h2> Kekenyalan <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                   <br>
                    <w-radios
                         class="mr2"
                         v-model="form.kekenyalan_ovari"
                         :items="vulva_list"
                         inline
                         :disabled="form.hantar==1"
                         color="blue-light1">
                       </w-radios>
                       <template v-if="form.kekenyalan_ovari==2">
                     <w-input class="mt4" label="Jika ABNORMAL, sila nyatakan *" type="text"  v-model="form.kekenyalan_ovari_nyatakan" />
                   </template>
               </div>
               <div style="margin-top: 30px">
                   <span style="color: black"><h2>4. Kehadiran Discaj <w-icon class="fal fa-info-circle"></w-icon></h2></span>
                   <br>
                    <w-radios
                         class="mr2"
                         v-model="form.kehadiran"
                         :items="tanda_list"
                         inline
                         :disabled="form.hantar==1"
                         color="blue-light1">
                       </w-radios>
                       <template v-if="form.kehadiran==1">
                     <w-input class="mt4" label="Jika YA, sila nyatakan warna*" type="text"  v-model="form.kehadiran_nyatakan" />
                   </template>
               </div>
             </div>
         </div>
      </div>
   </template>

</w-flex>
  </w-card>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'PEMERIKSAAN REKOD KESIHATAN'" >
    <div class="w-card__content content-hardcode">
    <template v-if="form.jantina==2">
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
          <span style="color: black"><h2> Saringan Penyakit Brucellosis </h2></span>
          <br>
            <w-radios
                class="mr2"
                v-model="form.brucellosis"
                :items="kasihatan_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          </div>
        </div>
      <br>
       <!-- <div class="grow " >
        <span style="color: black"><h2> Tanda Klinikal Penyakit </h2></span>
          <br>
         <w-radios
                class="mr2"
                v-model="form.tanda_klinikan"
                :items="kasihatan_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          </div> -->
        </template>
        <template v-if="form.jantina==1">
      <div class="w-flex wrap smd-column" >
        <div class="grow " >
            <span style="color: black"><h2> Saringan Penyakit Brucellosis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
              <w-radios
                  class="mr2"
                  v-model="form.brucellosis"
                  :items="kasihatan_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
            </div>
          </div>
        <br>
         <div class="grow " >
          <span style="color: black"><h2> Saringan Penyakit Trichnomoniasis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
           <w-radios
                  class="mr2"
                  v-model="form.trichnomoniasis"
                  :items="kasihatan_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
            </div>
            <br>
         <div class="grow " >
          <span style="color: black"><h2> Saringan Penyakit Camplylobacteriosis <w-icon class="fal fa-info-circle"></w-icon></h2></span>
            <br>
           <w-radios
                  class="mr2"
                  v-model="form.camplylobacteriosis"
                  :items="kasihatan_list"
                  inline
                  :disabled="form.hantar==1"
                  color="blue-light1">
                </w-radios>
            </div>
          </template>
      </div>
  </w-card>
    <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'SIFAT TERNAKAN'" >
   <div class="w-card__content content-hardcode">
      <div class="grow " >
            <w-radios
                class="mr2"
                v-model="form.temprament"
                :items="temprament_list"
                inline
                :disabled="form.hantar==1"
                color="blue-light1">
              </w-radios>
          </div>
      </div>
  </w-card>
    <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'STATUS PEMERIKSAAN'" >
    <div class="w-card__content content-hardcode">
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
      <w-radios
          class="mr2"
          v-model="form.lkp_status_id"
          :items="status_list"
          inline
          :disabled="form.hantar==1"
          color="blue-light1">
        </w-radios>
         <template v-if="form.lkp_status_id==3">
               <w-input class="mt4" label="Jika LULUS BERSYARAT, sila nyatakan *" type="text"  v-model="form.status_nyatakan" />
             </template>
          </div>
        </div>
      </div>
  </w-card>
  <w-card title-class="blue-dark4--bg white" style="font-size: 13px;"  :title="'Ulasan Pengesyoran'" >
    <div class="w-card__content content-hardcode">
    <div class="w-flex wrap smd-column" >
        <w-input class="mt4" label="Ulasan Pengesyoran"  v-model="form.ulasan" :disabled="form.hantar==1"  :validators="[validators.required]"/>
      </div>
    </div>
  </w-card>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['4']) && form.hantar!=1">
        <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
        <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
  </z-page>
    </w-form>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object],
  

  },
  data() {
    return {
      resourceurl: 'pdbf.penilaian',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Penilaian Daya Biak & Fertiliti', route: '/pdbf' },
        { label: 'Penilaian', route: '/pdbf/penilaian' },
      ],
      negeri : '',
      title : 'PDBF  Penilaian',
      form : this.d_form,
      
      lkp_status : [],
      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      testislist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"}
      ],
      skorlibidolist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"},
        {value: 6, label: "5"},
        {value: 7, label: "6"},
        {value: 8, label: "7"},
        {value: 9, label: "8"},
        {value: 10, label: "9"},
        {value: 11, label: "10"}
      ],
      skrotumlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      pungutan_list:[
        {value: 1, label: "PALPASI REKTAL"},
        {value: 2, label: "ELEKTROEJAKULASI"},
        {value: 3, label: "VAGINAL TIRUAN"}
      ],
      motilitilist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"},
        {value: 6, label: "5"}
      ],
      vulva_list:[
        {value: 1, label: "NORMAL"},
        {value: 2, label: "ABNORMAL"},
      ],
      kasihatan_list:[
        {value: 1, label: "POSITIF"},
        {value: 2, label: "NEGATIF"},
        {value: 3, label: "BELUM DI UJI"},

      ],
      tanda_list:[
        {value: 1, label: "YA"},
        {value: 2, label: "TIDAK"},
      ],
      lokasi_list:[
        {value: 1, label: "PELVIC"},
        {value: 2, label: "ABDOMEN"},
      ],
      bentuk_list:[
        {value: 1, label: "LURUS"},
        {value: 2, label: "BENGKOK"},
      ],
      temprament_list:[
        {value: 1, label: "JINAK"},
        {value: 2, label: "AGRESIF"},
      ],
      status_list:[
        {value: 1, label: "LULUS"},
        {value: 2, label: "GAGAL"},
        {value: 3, label: "LULUS BERSYARAT"},

      ],
      loading : 0,
      checkin:false,
    
    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
    },

    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('pdbf.penilaian.index', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('pdbf.penilaian.index',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('pdbf.penilaian.index'));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('pdbf.penilaian.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('pdbf.penilaian.form', res.id));

          })
        }
      } 
      
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_lgb', {}).then(res => {
        this.lkp_status = res
      })
    },


     tutup(){
         window.location.href = window.route('pdbf.penilaian.index')+'?pdbf_id='+this.form.pdbf_id;
       },



  
  },

  watch: {

  },
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.form.jantina==1)
    {
      this.title = 'Rekod Maklumat Penilaian Dayabiak Jantan'
    }
    else
    {
      this.title = 'Rekod Maklumat Penilaian Fertiliti Betina'
    }
    this.getStatus();
    
  }
    
}
</script>
<style type="text/css">
   .fa-info-circle {
  background-color: #234781;
  color:white;
}
</style>
